<br>
<div class="col-lg-12">
  <h4 style="text-align: center;">LIQUIDACIONES GUARDADAS</h4>
  <br>

  <!-- Barra de filtros -->
  <div>
    <label>CUIT:</label>&nbsp;
    <app-cuit-input [(ngModel)]="filtroCuit" inputStyle="width: 140px;"></app-cuit-input>
    &nbsp;&nbsp;
    <label>EMPRESA:</label>&nbsp;
    <input style="width: 200px;" type="text" [(ngModel)]="filtroEmpresa" placeholder="Nombre de empresa"
           (keyup.enter)="buscar()">
    &nbsp;&nbsp;
    <button type="button" class="btn btn-primary" (click)="buscar()" [disabled]="loading">
      <span *ngIf="!loading"><i class="fa fa-search"></i> BUSCAR</span>
      <span *ngIf="loading"><i class="fa fa-spinner fa-spin"></i> BUSCANDO...</span>
    </button>
    &nbsp;
    <button type="button" class="btn btn-secondary" (click)="limpiarFiltros()">
      <i class="fa fa-eraser"></i> LIMPIAR
    </button>
    &nbsp;
    <button type="button" class="btn btn-success" routerLink="/liquidaciones">
      <i class="fa fa-plus"></i> NUEVA LIQUIDACION
    </button>
  </div>

  <hr>

  <!-- Tabla de resultados -->
  <div *ngIf="dataSource.length > 0" class="animated fadeIn">

    <!-- Paginador superior -->
    <div class="custom-paginator">
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} liquidaciones</span>
      </div>

      <div class="paginator-page-size">
        <label>Por página:&nbsp;</label>
        <select [(ngModel)]="pageSize" (change)="changePageSize(pageSize)" class="form-control form-control-sm" style="width: auto; display: inline-block;">
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="50">50</option>
        </select>
      </div>

      <div class="paginator-navigation">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(0)" title="Primera página">
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)" title="Página anterior">
          <i class="fa fa-angle-left"></i>
        </button>

        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'"
                  class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>

        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(pageIndex + 1)" title="Página siguiente">
          <i class="fa fa-angle-right"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(getTotalPages() - 1)" title="Última página">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <table class="table table-bordered table-striped table-hover table-sm">
      <thead class="thead-dark">
        <tr>
          <th>ID</th>
          <th>CUIT</th>
          <th>EMPRESA</th>
          <th>PERIODO</th>
          <th>FECHA LIQ.</th>
          <th style="text-align: right;">TOTAL ADEUDADO</th>
          <th>CREADA</th>
          <th>USUARIO</th>
          <th style="text-align: center;">ACCIONES</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataSource">
          <td>{{item.id}}</td>
          <td>{{item.cuit}}</td>
          <td>{{item.empresa}}</td>
          <td>
            <span *ngIf="item.anio_desde === item.anio_hasta">{{item.anio_desde}}</span>
            <span *ngIf="item.anio_desde !== item.anio_hasta">{{item.anio_desde}} - {{item.anio_hasta}}</span>
          </td>
          <td>{{item.fecha_liquidacion}}</td>
          <td style="text-align: right; font-weight: bold;">$ {{formatCurrency(item.total_adeudado)}}</td>
          <td>{{item.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
          <td>{{item.created_by}}</td>
          <td style="text-align: center; white-space: nowrap;">
            <button type="button" class="btn btn-sm btn-info" (click)="editar(item.id)" title="Editar">
              <i class="fa fa-edit"></i>
            </button>
            &nbsp;
            <button type="button" class="btn btn-sm btn-danger" (click)="eliminar(item)" title="Eliminar">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginador inferior -->
    <div class="custom-paginator">
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} liquidaciones</span>
      </div>

      <div class="paginator-navigation">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(0)">
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          <i class="fa fa-angle-left"></i>
        </button>

        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'"
                  class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>

        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(pageIndex + 1)">
          <i class="fa fa-angle-right"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(getTotalPages() - 1)">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mensaje cuando NO hay resultados -->
  <div *ngIf="!loading && dataSource.length === 0" class="animated fadeIn">
    <br>
    <div class="alert alert-info" role="alert">
      <i class="fa fa-info-circle"></i>
      No se encontraron liquidaciones guardadas.
    </div>
  </div>
</div>
<br><br>
